// File: src/blueprint/state/useBlueprintState.js

/**
 * GOAL:
 * - Expose Blueprint Runner state via a simple hook API.
 *
 * OUT OF SCOPE (for now):
 * - Async loading, persistence, server sync.
 */

import { useContext } from 'react';
import { BlueprintContext } from './BlueprintProvider.jsx';

export function useBlueprintState() {
  return useContext(BlueprintContext);
}
